<!-- <app-loader *ngIf="showSpinner"> </app-loader> -->
<main class="content-wrapper" [ngStyle]="{ background: selectedMode === 'dark' ? '#111526' : '' }">
  <div class="container-fluid mb-4">
    <form ng-form="form1" #f="ngForm" (ngSubmit)="onSubmit(f)">
      <div class="col-12">
        <div class="new-password p-4 " [ngClass]="{ 'dark-backround': selectedMode === 'dark' }">
          <div class="password-heading mb-4">
            <h1>Set New Password</h1>

          </div>
          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <div class="form-group new-password-field">
                  <input type="password" name="OldPassword" id="oldPassword" class="form-control pl-4" ngModel
                    #title="ngModel" placeholder="Old Password" />
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group new-password-field">
                <input type="password" name="newPassword" id="new_password" class="form-control pl-4" ngModel
                  #title="ngModel" placeholder="New Password" />
              </div>
            </div>
            <div class="col-md-6 mt-2">
              <div class="form-group new-password-field">
                <input type="password" name="confirmnewPassword" id="confirm_new_password" class="form-control pl-4"
                  ngModel #title="ngModel" placeholder="Conform New Password" />
              </div>
            </div>
            <div class="col-12 set-password-btn mt-5">
              <div class="col-7 row text-right">
                <div class="col-8 reset-btn">
                  <div data-toggle="modal"
                  data-target="#passwordModal">Reset Password To Default </div>
                </div>
                <div class="col-4 p-0">
                  <button class="btn btn-primary" type="submit">Update</button>
                </div>
              </div>

            </div>
          </div>
        </div>

      </div>

    </form>

    <form ng-form="form1" #p="ngForm" (ngSubmit)="updatePin(p)">
      <div class="col-12">
        <div class="new-password p-4 mt-4" [ngClass]="{ 'dark-backround': selectedMode === 'dark' }">
          <div class="password-heading mb-4">
            <h1>Set New Salary Pin Code</h1>

          </div>
          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <div class="form-group new-password-field">
                  <input type="text" name="oldPin" id="oldPin" class="form-control pl-4" ngModel #title="ngModel"
                    placeholder="Old Pin Code" />
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group new-password-field">
                <input type="text" name="newPin" id="new_pin" class="form-control pl-4" ngModel #title="ngModel"
                  placeholder="New Pin Code" />
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group new-password-field">
                <input type="text" name="confirmNewPin" id="confirm_new_pin" class="form-control" ngModel
                  #title="ngModel" placeholder="Conform Pin Code" />
              </div>
            </div>
            <div class="col-12 text-center set-password-btn mt-5">

              <div class="col-7 row text-right">
                <div class="col-8 reset-btn">
                  <div data-toggle="modal"
                  data-target="#pinModal">Reset Pin Code To Default </div>
                </div>
                <div class="col-4 p-0">
                  <button class="btn btn-primary" type="submit">Update</button>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>

    </form>

      <div class="col-12">
        <div class="new-password p-4 mt-4" [ngClass]="{ 'dark-backround': selectedMode === 'dark' }">
          <div class="password-heading mb-4">
            <h1>Your Device Unique ID</h1>

          </div>
          <div class="row">

            <div class="col-md-12">
              <div class="form-group new-password-field">
                <input type="text" name="newPin" id="new_pin" class="form-control pl-4"
                  value={{this.deviceUuid}} readonly/>
              </div>
            </div>
<div class="col-12 text-center set-password-btn mt-3">

              <div class="col-7 row text-right">
                <div class="col-8 reset-btn">
                  <!-- <a>Reset Pin Code To Default </a> -->
                </div>
                <div class="col-4 p-0">
                  <button class="btn btn-primary" (click)="copyToDeviceUuid()">Copy</button>
                </div>
              </div>
            </div>

          </div>
        </div>

      </div>

      <div class="modal fade" id="passwordModal" tabindex="-1" role="dialog" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="document">
          <div class="modal-content" [ngClass]="{ 'dark-backround': selectedMode === 'dark' }">
            <div class="modal-header" [ngClass]="{ 'dark-backround-inner': selectedMode === 'dark' }">
              <h5 class="modal-title" id="exampleModalLongTitle">Conformation</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body" [ngClass]="{ 'dark-backround-inner': selectedMode === 'dark' }">
              <p>Are you sure you want to <b>Reset Password ? </b></p>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-dismiss="modal">No</button>
              <button type="button" (click)="resetPassword()" data-dismiss="modal" class="btn btn-danger">Yes</button>
            </div>
          </div>
        </div>
      </div>



      <div class="modal fade" id="pinModal" tabindex="-1" role="dialog" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="document">
          <div class="modal-content" [ngClass]="{ 'dark-backround': selectedMode === 'dark' }">
            <div class="modal-header" [ngClass]="{ 'dark-backround-inner': selectedMode === 'dark' }">
              <h5 class="modal-title" id="exampleModalLongTitle">Conformation</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body" [ngClass]="{ 'dark-backround-inner': selectedMode === 'dark' }">
              <p>Are you sure you want to <b>Reset Pin Code ? </b></p>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-dismiss="modal">No</button>
              <button type="button" (click)="resetPin()" data-dismiss="modal"  class="btn btn-danger">Yes</button>
            </div>
          </div>
        </div>
      </div>

  </div>
</main>
